import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  value: {},
  loading: false,
}

export const DeletespeakersSlice = createSlice({
  name: 'Deletespeakers',
  initialState,
  reducers: {
    Delete_speakers_request: (state, action) => {
      state.value = {};
      state.loading = true;
    },
    Delete_speakers_success: (state, action) => {

      state.value = action.payload;
      state.loading = false;
      state.error = {};

    },
    Delete_speakers_failure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
      state.value = {};
    },
    Clear_Delete_speakers_Check: (state, action) => {
      state.value = {}
      state.error = {};
      state.loading = false;
    },
  }
})

// Action creators are generated for each case reducer function
export const {Delete_speakers_request, Delete_speakers_success, Delete_speakers_failure, Clear_Delete_speakers_Check } = DeletespeakersSlice.actions

export default DeletespeakersSlice.reducer